import { SET_USER } from '../../utils/constants/action-types';

const initalUserState = {
  user: null,
  error: null,
  isAuthenticated: false,
};

const reducer = (state = initalUserState, action: any) => {
  switch (action.type) {
    case SET_USER: {
      return { ...state, user: action.payload, isAuthenticated: !!action.payload };
    }
    default: {
      return state;
    }
  }
};
export { reducer as UserReducer };
